import type { ReactElement } from 'react';
import { isElement } from 'react-is';
import { twMerge } from 'cn';
import type { PlaceholderProps } from './types.js';

/** `<Placeholder>` component. */
export const Placeholder = ({ className, message, ...props }: PlaceholderProps): ReactElement => (
  <div
    className={twMerge(
      'grid aspect-video content-center justify-center rounded border border-base-100 bg-black px-32 text-center text-sm font-regular text-muted',
      className
    )}
    {...props}
  >
    {isElement(message) ? message : <p>{message}</p>}
  </div>
);
